import React from "react";
import ServicesLayout from "../../../Utils/Serviceslayout/serviceslayout";
import { image } from "../../../Assets";

const Twodn3drenderservice = () =>{
    return(
        <ServicesLayout mainservice="Visualisation"  serviceName="2D/3D Rendering" maincontent="Impactful visualization is the most effective VDC/BIM communication tool. We use advanced 2D/3D techniques and provide the end user with realistic options to assist in project decision making."
        content="Fractile provides customized rich rendering solutions in both 2D and 3D environments, utilizing multiple mediums to enhance user experience and decision-making capabilities. Our rendering services offer photorealistic representations of architectural designs and construction projects, empowering stakeholders to visualize concepts with unparalleled clarity and detail."
        banner={image.render2dn3d} banner2={image.render2dn3d2} banner3={image.render2dn3d3}
        />
    )
}

export default Twodn3drenderservice;